<template>
  <div>
    <Header :self="self" />
    <div class="container main">
      <div class="alert alert-danger" role="alert" v-if="error">
        {{error.message}}
      </div>
      <div class="alert alert-success" role="alert" v-show="success">
        Thanks! Your message has been sent. We'll be in touch shortly.
      </div>
      <form @submit.prevent="send" :disabled="submitting.send" v-show="!success">
        <div class="form-group row" v-bind:class="{ 'form-group-error': $v.contact.name.$error }">
          <label for="name" class="col-sm-2 col-form-label">Name</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="name" placeholder="Your Name" v-model="contact.name" v-model.trim.lazy="$v.contact.name.$model">
            <div class="error-input">Please provide your name</div>
          </div>
        </div>
        <div class="form-group row" v-bind:class="{ 'form-group-error': $v.contact.email.$error }">
          <label for="email" class="col-sm-2 col-form-label">Email Address</label>
          <div class="col-sm-10">
            <input type="email" class="form-control" id="email" placeholder="Your Email Address" v-model="contact.email" v-model.trim.lazy="$v.contact.email.$model">
            <div class="error-input">Please provide your email</div>
          </div>
        </div>
        <div class="form-group row" v-bind:class="{ 'form-group-error': $v.contact.subject.$error }">
          <label for="subject" class="col-sm-2 col-form-label">Subject</label>
          <div class="col-sm-10">
            <input type="text" class="form-control" id="subject" placeholder="Message Subject" v-model="contact.subject" v-model.trim.lazy="$v.contact.subject.$model">
            <div class="error-input">Please provide a subject</div>
          </div>
        </div>
        <div class="form-group" v-bind:class="{ 'form-group-error': $v.contact.message.$error }">
          <textarea v-model="contact.message" v-model.trim.lazy="$v.contact.message.$model" class="form-control quote" placeholder="Please type your message"></textarea>
          <div class="error-input">Please provide a message</div>
        </div>
        <div class="text-right">
          <button class="btn btn-primary" @click="send(contact)" :disabled="submitting.send">Send Message</button>
        </div>
      </form>
    </div>
    <Footer />
  </div>
</template>

<script>
  import Header from "@/components/header";
  import Footer from "@/components/footer";
  import { mapState, mapActions } from "vuex";
  import { required } from "vuelidate/lib/validators";

  export default {
    components: { Header, Footer },
    data() {
      return {
        contact: {},
        error: null,
        success: false,
        submitting: { send: false },
      };
    },
    head() {
      return {
        title: "Quozio - Contact Us",
        meta: [
          { hid: "description", name: "description", content: "Contact Quozio Support" }
        ]
      }
    },
    async asyncData({ store, app }) {
      await store.dispatch("self/get", app.$cookies);
    },
    methods: {
      async send() {
        this.error = null;

        this.$v.$touch();
        if (this.$v.$invalid) {
          return;
        }

        this.submitting.send = true;
        this.success = false;
        this.$nuxt.$loading.start();
        let response = await this.$dataService.post("/tools/contact", this.contact);
        this.submitting.send = false;
        if (response.error) {
          this.error = response.error;
          this.$nuxt.$loading.finish();
          return;
        }

        this.success = true;
        this.$nuxt.$loading.finish();

      },
    },
    computed: {
      ...mapState("self", { self: "self" }),
    },
    validations: {
      contact: {
        name: {
          required
        },
        email: {
          required
        },
        subject: {
          required
        },
        message: {
          required
        }
      }
    }
  };
</script>
